import { COMPARE_MAX_IMAGES } from '@vizit/collections';

const IDS_SEPARATOR = ',';
const IMAGE_ID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

function parseCompareIds(value: unknown): string[] {
  if (typeof value !== 'string') return [];
  const ids = value.split(IDS_SEPARATOR).map((id) => id.trim());
  return [...new Set(ids)].filter((id) => IMAGE_ID_PATTERN.test(id)).slice(0, COMPARE_MAX_IMAGES);
}

function formatCompareIds(ids: string[]): string | undefined {
  return ids.length ? ids.join(IDS_SEPARATOR) : undefined;
}

export { formatCompareIds, parseCompareIds };
